import { InteractionEvent } from '../interaction-event.model';
import { TrackingService } from './tracking-service.interface';

export class IntercomTracker implements TrackingService {
  trackEvent(event: InteractionEvent): void {
    window.Intercom('trackEvent', event.eventName, event);
  }
}
